export enum BankConnectivityProvider {
    Stripe = 'Stripe',
    GoCardLess = 'GoCardLess',
    Plaid = 'Plaid',
    Codat = 'Codat',
    Rutter = 'Rutter',
    Documents = 'Documents',
    Wise = 'Wise',
    OrdersHistory = 'OrdersHistory',
    ExternalFiles = 'ExternalFiles',
    Other = 'Other',
    PersonalGuarantee = 'PersonalGuarantee',
    Airwallex = 'Airwallex',
}

export enum SupplierDataConnectionProvider {
    Codat = 'Codat',
    Rutter = 'Rutter',
    Odoo = 'Odoo',
}
